module.exports = __webpack_public_path__ + "img/open.e6d0c2c4.svg";